import { Row, Col, Modal, Form, Input, Select, Switch } from "antd";
import React, { useState, useEffect, useRef } from "react";
import JoditEditor from "jodit-react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

const { Option } = Select;

const PolicyForm = ({ show, hide, data, refresh, isUpdate }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const editorRef = useRef(null);
  const [content, setContent] = useState("");
  const [formData, setFormData] = useState("");

  // SUBMIT
  const onSubmit = (values) => {
    setLoading(true);

    const payload = {
      type: values.type,
      version: values.version,
      content,
      publish: formData.publish || "DRAFT",
    };

    request({
      url: isUpdate
        ? `${apiPath.updatePolicy}/${data._id}`
        : apiPath.publishPolicy,
      method: isUpdate ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handlePublishChange = (checked) => {
    const publishStatus = checked ? "PUBLISH" : "DRAFT";

    setFormData((prev) => ({
      ...prev,
      publish: publishStatus,
    }));
  };

  // PREFILL DATA (EDIT MODE)
  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      type: data.type,
      version: data.version,
      publish: data.status,
      //   changeType: data.changeType || "MINOR",
    });

    setContent(data.content || "");
  }, [data]);

  return (
    <Modal
      width={900}
      open={show}
      title={isUpdate ? "Update Policy" : "Create New Policy"}
      okText={isUpdate ? "Update" : "Create"}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: 8 }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "policy-form",
        htmlType: "submit",
        loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form id="policy-form" form={form} onFinish={onSubmit} layout="vertical">
        <Row gutter={[16, 16]}>
          {/* Policy Type */}
          <Col span={12}>
            <Form.Item
              label="Policy Type"
              name="type"
              rules={[{ required: true, message: "Select policy type" }]}
            >
              <Select disabled={isUpdate}>
                <Option value="TERMS">Terms & Conditions</Option>
                <Option value="PRIVACY">Privacy Policy</Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Version */}
          <Col span={12}>
            <Form.Item
              label="Version"
              name="version"
              rules={[{ required: true, message: "Enter version" }]}
            >
              <Input placeholder="e.g. 1.0, 1.1, 2.0" disabled={isUpdate} />
            </Form.Item>
          </Col>

          {/* <Col span={12}>
            <Form.Item
              label="Change Type"
              name="changeType"
              rules={[{ required: true }]}
            >
              <Select disabled={data?.isActive}>
                <Option value="MINOR">Minor (typo / formatting)</Option>
                <Option value="MAJOR">Major (legal change)</Option>
              </Select>
            </Form.Item>
          </Col> */}

          {/* Publish */}
          <Col span={12}>
            <Form.Item
              label="Publish Policy"
              name="publish"
              valuePropName="checked"
            >
              <Switch
                checked={formData.publish === "PUBLISH"}
                checkedChildren="Published"
                unCheckedChildren="Draft"
                onChange={handlePublishChange}
              />
            </Form.Item>
          </Col>

          {/* Policy Content */}
          <Col span={24}>
            <Form.Item label="Policy Content" required>
              <JoditEditor
                ref={editorRef}
                value={content}
                onBlur={(newContent) => setContent(newContent)}
                config={{
                  readonly: false,
                  height: 400,
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default PolicyForm;
